import type { LotteryId } from '#api/shared/@types/generated/backend/graphql-schema-types'

import type { Config, ReactiveSource } from '../@types/editor'

import { type EditorPlay, usePickLotteryStore } from '../stores/pickLottery'

export const usePickLotteryDisabledFields = (
  lotteryId: LotteryId,
  configRef: ReactiveSource<Config>,
  playRef: ReactiveSource<EditorPlay>,
) => {
  const store = usePickLotteryStore(lotteryId)

  const config = computed(() => toValue(configRef))
  const play = computed(() => toValue(playRef))

  const disabledFields = computed(() =>
    store.getDisabledFieldNames(config.value, play.value.perPlayAddOn?.value ?? null),
  )

  const isDisabled = (field: string) => disabledFields.value.includes(field)

  return { disabledFields, isDisabled }
}
